import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';

export const FILES_TOUR_ID = 'files.intro';

registerTour({
  id: FILES_TOUR_ID,
  name: 'Files',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.FILES.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Files',
      body:
        'A central place to store and share project documents — contracts, ' +
        'specs, drawings, photos, anything else you need to keep with the project.',
    },
    {
      id: 'header-actions',
      target: '[data-tour-id="files-header-actions"]',
      placement: 'left',
      spotlightPadding: 4,
      title: 'Create folders & upload',
      body:
        'Create a new folder to organize files, or upload files directly ' +
        'into the folder you\u2019re currently viewing.',
    },
    {
      id: 'tree',
      target: '[data-tour-id="files-tree"]',
      placement: 'right',
      spotlightPadding: 4,
      title: 'Folder tree',
      body:
        'Navigate the full folder structure of the project. Click any ' +
        'folder to jump straight to it.',
    },
    {
      id: 'search',
      target: '[data-tour-id="files-search"]',
      placement: 'bottom',
      spotlightPadding: 4,
      title: 'Search this folder',
      body: 'Filter the current folder by file or folder name.',
    },
    {
      id: 'browser',
      target: '[data-tour-id="files-browser"]',
      placement: 'top',
      spotlightPadding: 4,
      title: 'Browse, select & manage',
      body:
        'Click rows to open or download. Use the checkboxes to multi-select ' +
        'and then move, download, or delete in bulk.',
    },
  ],
});
